import React from "react";
import s from "./styles.scss";
import { Styled } from "../../../toolkit/decorators/Artifact";
import { CodigoEmpleadoAdminStore } from "../../containers/codigoEmpleadoAdmin/CodigoEmpleadoAdmin.store";
import { CodigoEmpleadoAdminDispatcher } from "../../containers/codigoEmpleadoAdmin/CodigoEmpleadoAdmin.dispatcher";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfig, Inputs, Buttons } from "./CodigoEmpleadoAdmin.form";
import { MemoTable } from "./CodigoEmpleadoAdmin.table";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import { downloadCodigosRedimidosReporte } from "../../actions/codigosEmpleado";

interface Props
  extends CodigoEmpleadoAdminStore,
    CodigoEmpleadoAdminDispatcher {}

interface State {
  idUser: any;
  downloading: boolean;
}

@Styled(s)
export default class CodigoEmpleadoAdmin extends React.Component<Props, State> {
  state: State = {
    idUser: null,
    downloading: false
  };

  componentDidMount() {
    const { FRIENDS_AND_FAMILY_ADMIN } = permissionCodes;

    if (userHasPermission(FRIENDS_AND_FAMILY_ADMIN)) {
      this.props.clearCodigosEmpleado();
    } else {
      this.setState({ idUser: 0 });
      this.props.getCodigosEmpleadoByUser(0);
    }
  }

  submit = async (values: any) => {
    const { tipoBusqueda, idUser, codigo } = values;
    let preview;
    this.setState({ idUser: null });

    if (!tipoBusqueda) {
      this.setState({ idUser });
      preview = await this.props.getCodigosEmpleadoByUser(idUser);
    } else if (tipoBusqueda === "CODIGO") {
      preview = await this.props.getCodigosEmpleadoByCodigo(codigo);
    }

    if (!preview.fulfilled) {
      errorNotification(preview.gettingCodigosEmpleadoError);
    }
  };

  handleCrearCodigo = async idUser => {
    if (idUser === null) {
      return;
    }

    const preview = await this.props.postCodigoEmpleado(idUser);
    if (preview.fulfilled) {
      successNotification("Código creado exitosamente");
      await this.props.getCodigosEmpleadoByUser(idUser);
    } else {
      errorNotification(preview.postingCodigoEmpleadoError);
    }
  };

  handleEnviarComunicado = async idUser => {
    if (idUser === null) {
      return;
    }

    const preview = await this.props.postEnviarComunicadoCodigosEmpleado(
      idUser
    );
    if (preview.fulfilled) {
      successNotification("Comunicado enviado correctamente");
    } else {
      errorNotification(preview.postingEnviarComunicadoError);
    }
  };

  handleDescargarReporte = () => {
    this.setState({ downloading: true });

    downloadCodigosRedimidosReporte(error => {
      this.setState({ downloading: false });

      if (!error) {
        successNotification("Reporte descargado correctamente");
      }
    });
  };

  render() {
    const {
      codigosEmpleado,
      gettingCodigosEmpleado,
      postingCodigoEmpleado,
      postingEnviarComunicado
    } = this.props;
    const { FRIENDS_AND_FAMILY_ADMIN } = permissionCodes;
    const hasAdminPermission = userHasPermission(FRIENDS_AND_FAMILY_ADMIN);
    const loading =
      gettingCodigosEmpleado ||
      postingCodigoEmpleado ||
      postingEnviarComunicado ||
      this.state.downloading;

    return (
      <div className="container">
        {hasAdminPermission && (
          <div>
            <FormBuilder<Inputs, Buttons>
              config={formConfig}
              submit={this.submit}
              processing={loading}
            >
              <IButtonBuilder
                name="descargar"
                onClick={this.handleDescargarReporte}
              />
            </FormBuilder>
          </div>
        )}

        {!hasAdminPermission && (
          <div className="alert alert-info" style={{ margin: "24px -15px" }}>
            Puede compartir sus códigos de descuento con familiares y amigos
            para que reciban grandes descuentos
          </div>
        )}

        {codigosEmpleado && codigosEmpleado.length >= 0 && (
          <MemoTable
            codigos={codigosEmpleado}
            loading={loading}
            handleCrearCodigo={this.handleCrearCodigo}
            handleEnviarComunicado={this.handleEnviarComunicado}
            idUser={this.state.idUser}
          />
        )}
      </div>
    );
  }
}
